
/**
 * Return whether the coupon applied to the line is applicable based on
 * its duration scheme and redemptions.
 * @param {*} line subscription line with potential coupon and redemptions
 * @returns {boolean} true if the coupon is applicable, false otherwise
 */
export function isCouponApplicable (line) {
  const coupon = line?.coupon
  if (!coupon) {
    return false
  }

  const scheme = coupon.duration_scheme
  const redemptions = Number(line.coupon_redemptions || 0)

  if (scheme === 'forever') {
    return true
  }

  if (scheme === 'one_time') {
    return redemptions === 0
  }

  if (scheme === 'limited') {
    const times = Number(coupon.duration_times || 0)
    return times > redemptions
  }

  return false
}